import { FC, useState } from 'react';
import { IDish } from '../../../../types/dishes.types';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { COLORS, FONTS } from '../../../../constants';
import { Button } from '../../../../components/Button';
import { convertPrice } from '../../../../services/utils';
import RenderHTML from 'react-native-render-html';
import { htmlDecode } from '../../../../services/utils/htmlDecode';
import { STYLE_VARS } from '../../../../constants/style-vars';
import { IExtraDish } from '../../../../types/dishes.types';

interface AdditionalMealItemProps {
  item: IExtraDish;
  onUpdateQuantity: (dish: IExtraDish, type: 'add' | 'minus') => void;
}

const AdditionalMealItem: FC<AdditionalMealItemProps> = ({
  item,
  onUpdateQuantity,
}) => {
  const handleAddPeople = () => {
    onUpdateQuantity(item, 'add');
  };

  const handleMinusPeople = () => {
    onUpdateQuantity(item, 'minus');
  };

  return (
    <View
      style={{
        width: '100%',
      }}
      key={`${item.dish.id}-${item.type}`}
    >
      <TouchableOpacity
        style={{
          marginBottom: 7,
        }}
        onPress={() => {}}
      >
        <Image
          source={
            item.dish.image
              ? {
                  uri: item.dish.image,
                }
              : require('../../../../assets/dish-image.png')
          }
          style={[
            {
              width: '100%',
              borderRadius: 18,
              height: 170,
            },
          ]}
        />
      </TouchableOpacity>
      <Text
        style={{
          fontFamily: FONTS.AvenirMedium,
          fontWeight: '800',
          fontSize: 19,
          color: COLORS.BLACK,
          marginBottom: 8,
        }}
      >
        {item.dish.name}
      </Text>
      <View
        style={{
          width: 60,
          height: 2,
          marginBottom: 8,
          backgroundColor: COLORS.RED_PRIMARY,
        }}
      />
      <Text
        style={{
          fontFamily: FONTS.AvenirMedium,
          fontWeight: '800',
          fontSize: 19,
          color: COLORS.RED_PRIMARY,
          marginBottom: 5,
        }}
      >
        {`HKD ${convertPrice(item.dish.price)}`}
      </Text>
      <View style={{ marginBottom: 5 }}>
        <Text
          style={{
            fontFamily: FONTS.AvenirMedium,
            fontSize: 14,
            fontWeight: '500',
            color: COLORS.GREY,
          }}
        >
          {'Number Of Meals:'}
        </Text>
      </View>
      <View style={styles.countContainer}>
        <TouchableOpacity onPress={handleMinusPeople} activeOpacity={1}>
          <Image
            style={styles.countBtnIcon}
            source={require('../../../../assets/minus-red-icon.png')}
          />
        </TouchableOpacity>
        <Text
          style={{
            ...styles.countNumber,
            paddingHorizontal: 10,
          }}
        >
          {item.quantity}
        </Text>
        <TouchableOpacity activeOpacity={1} onPress={handleAddPeople}>
          <Image
            style={styles.countBtnIcon}
            source={require('../../../../assets/add-icon.png')}
          />
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default AdditionalMealItem;

const styles = StyleSheet.create({
  countContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  countBtn: {},
  countBtnIcon: {
    width: 20,
    height: 20,
  },
  countNumber: {
    fontSize: 12,
    color: COLORS.BLACK,
    fontFamily: STYLE_VARS.avenirMediumFont,
  },
});
